
import React from 'react';
import { Calculator } from '../types';
import { Icon } from './Icon';
import { CATEGORIES_CONFIG } from '../constants';

interface CalculatorCardProps {
  calc: Calculator;
  onSelect: (slug: string) => void;
}

export const CalculatorCard: React.FC<CalculatorCardProps> = ({ calc, onSelect }) => {
  const categoryConfig = CATEGORIES_CONFIG.find(c => c.id === calc.category);
  const accentColor = categoryConfig?.color || 'text-indigo-600';
  const glowBg = categoryConfig?.bg || 'bg-indigo-50';

  return (
    <div
      onClick={() => onSelect(calc.slug)}
      className="group relative bg-theme-card rounded-3xl border border-theme-border p-7 transition-all duration-500 hover:shadow-[0_20px_50px_rgba(79,70,229,0.12)] hover:-translate-y-2 hover:scale-[1.02] cursor-pointer flex flex-col h-full overflow-hidden"
    >
      <div className="flex items-start justify-between mb-6 relative z-10">
        <div className={`w-12 h-12 flex items-center justify-center ${accentColor} ${glowBg} dark:!bg-emerald-500/10 dark:!text-emerald-500 rounded-2xl transition-all duration-500 group-hover:rotate-[10deg] shadow-sm`}>
          <Icon name={calc.icon} className="w-6 h-6 stroke-[2] transition-transform duration-500 group-hover:scale-110" />
        </div>
        <div className="flex flex-col gap-1.5 items-end">
          {calc.isNew && (
            <span className="flex items-center gap-1 px-2.5 py-1 text-[9px] font-black uppercase tracking-wider text-emerald-600 bg-emerald-50 rounded-lg">
              <Icon name="sparkles" className="w-3 h-3" /> Novo
            </span>
          )}
          {calc.isPopular && (
            <span className="flex items-center gap-1 px-2.5 py-1 text-[9px] font-black uppercase tracking-wider text-amber-600 bg-amber-50 rounded-lg">
              <Icon name="star" className="w-3 h-3" /> Popular
            </span>
          )}
        </div>
      </div>

      <h3 className="text-lg font-extrabold text-theme-text mb-2.5 leading-tight group-hover:text-indigo-600 transition-colors duration-300">
        {calc.title}
      </h3>

      <p className="text-sm leading-relaxed text-theme-muted mb-8 flex-grow line-clamp-3 font-medium">
        {calc.description}
      </p>

      <div className="flex items-center text-xs font-black text-indigo-600 group-hover:text-indigo-700 uppercase tracking-widest relative z-10">
        Calcular Agora
        <Icon name="arrow-right" className="ml-2 w-4 h-4 transform transition-transform duration-500 group-hover:translate-x-2" />
      </div>
    </div>
  );
};
